<template>
  <div>
    <div v-show="!isLoading" class="content" id="main_display">
      <BasicInfo :info="info" v-on:loaded="isLoading = false" v-on:loading="isLoading = true"/>
      <div v-if="false && isStudent">
        <div style="font-weight: 600; font-size: 1.3rem; margin: 1rem 0">我的獎章展示櫃</div>
        <div class="profile-container" style="margin-bottom: 2rem; flex-direction: column">
          <div style="display: flex; justify-content: center; flex-wrap: wrap">
            <img style="margin-right: 1rem;" v-for="item in 5" :key="item" class="img_award" src="@/assets/image/award.png">
          </div>
          <div style="padding-top: 1rem;">
              <span style="float: right" id="btn-edit">挑選獎章展示</span>
          </div>
        </div>
      </div>
      <ResetPassword v-on:loaded="isLoading = false" v-on:loading="isLoading = true"/>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>

<style lang="scss" scoped>

#main_display{
  width: 80%;
  max-width: 800px;
  margin: auto;
}

.img_award{
  width: 8rem;
  height: 8rem;
  border-radius: 50%;
}
.profile-userInfo-details{
  display: flex;
  flex-wrap: wrap;
}

.profile-label{
  flex: 0 0 100px;
  margin: 1rem 0;
}

.profile-pw-label{
  flex: 0 0 150px;
  margin: 1rem 0;
}

.profile-field{
  flex: 1;
  padding: 0 1rem;
}

.profile-container{
  background-color: #f5f5f5;
  padding: 2rem 5rem;
  display: flex;
  justify-content: center;
  border-radius: 2.5rem;
  font-size: 1.2rem;
}
.profile-userIcon{
  flex: 0 0 15rem;
  align-self: center;
}
.profile-userInfo{
  flex: 1;
  padding-left: 3rem;
  font-size: 1.2rem;
  align-self: center;
}
#upload_btn{
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  color: #397f1f;
  font-weight: 600;
}

#upload_btn:hover{
  cursor: pointer;
  text-decoration: underline;
}
#btn-edit{
  color: #397f1f;
  font-weight: 600;
}
#btn-edit:hover{
  text-decoration: underline;
  cursor: pointer;
}
#img_profile_src{
    width: 15rem;
    height: 15rem;
    background: #e9e9e9;
    border-radius: 15rem;
    display: block;
    overflow: hidden;
}

input{
  border-radius: 1rem;
}
input:focus{
  box-shadow: 0 0 3px 0px #397f1f;
  outline: none;
}
label{
  align-self: center;
}

.wordbtn{
  color: #397f1f;
  font-weight: 600;
  padding-left: 1rem;
}
.wordbtn:hover{
  text-decoration: underline;
  cursor: pointer;
}
</style>

<script>
import Loading from '@/components/Utility/Loading.vue'
import ResetPassword from '@/components/Profile/ResetPassword.vue'
import BasicInfo from '@/components/Profile/BasicInfo.vue'
export default {
  components: {
    Loading, ResetPassword, BasicInfo
  },
  data () {
    return {
      isLoading: true,
      info: {},
      name: this.$store.getters.user.name,
      level: this.$store.getters.user.level,
      exp: this.$store.getters.user.exp
    }
  },
  computed: {
    isStudent: function () {
      return this.$parent.isStudent
    },
    isTeacher: function () {
      return this.$parent.isTeacher
    }
  },
  async mounted () {
    await this.$store.dispatch('getProfile').then(r => {
      this.info.id = r.id
      this.info.first_name = r.first_name
      this.info.last_name = r.last_name
      this.info.email = r.email
      this.info.school_faculty = r.school_faculty
      this.info.summary = r.summary
      this.info.profile_img = r.profile_img
      this.info.role = r.role
    })
    this.isLoading = false
  }
}
</script>
